import background from './background';
import feedback from './feedback';
import icons from './icons';
import logos from './logos';

import type { Images } from './types';

const images: Images = {
  background,
  feedback,
  icons,
  logos,
};

export default images;
